import type { ControllerBodyParameters, ControllerExecutionSuccessResult } from '@carlito/ddd';
import type { GuestLoginController } from '@carlito/hotel-apis';
import { apiRequest } from './api';

export type GuestLoginParams = ControllerBodyParameters<GuestLoginController>;
export type GuestLoginReponse = ControllerExecutionSuccessResult<GuestLoginController>;

export async function loginGuest(params: GuestLoginParams) {
  const result = await apiRequest<GuestLoginController>('/guest/login', {
    body: JSON.stringify(params),
    method: 'POST',
  });

  return result;
}
